




















































import { Component, Vue } from 'vue-property-decorator';   
import axios from 'axios';
import { General } from '@/services/General';
import ChangePassword from './ExternalUser/ChangePassword.vue';
import { CONTRACT_TYPE_ENUM } from '@/services/Enums';
import EmergencyContact from './EmergencyContact.vue';

@Component({
    components: {
        ChangePassword,
        EmergencyContact
    },
})
export default class UserProfile extends Vue {

    loading: boolean = false;
    selectedRegion: any = null;
    regionsOptions: any = [];
    rolesNames: string =''; 
    userProfile: any = {};
    userAuth: any = {};
    regionName: string = null;
    countryName: string = null;
    contractType: number = null;
    contractTypeName: string = null;
    locationName: string = null;
    CONTRACT_TYPE = CONTRACT_TYPE_ENUM;
    isEnableForEmergencyContact: boolean = false;

    async mounted()
    {
        
        this.loading = true;
        this.isEnableForEmergencyContact = await this.CheckAuthorization();
        await this.openModalProfile();
        await this.getFullUserProfile();
        let array = this.fillRolesArray(this.convertRolesToArrayString(this.userAuth.userRoles));
        this.rolesNames = General.fillArraySeparator(array, ', ');
        this.loading = false;
    }
    async getFullUserProfile() {
        try {                
            let response: any = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/UserProfile/GetFullUserProfile'),
                data: {
                },
                withCredentials: true,
                responseType: 'json'
            });
            if (response.data != null) {
                this.userAuth = response.data.userAuth;
                this.userProfile = response.data.userProfile;
                this.regionName = response.data.regionName;
                this.countryName = response.data.countryName;
                this.locationName = response.data.locationName;
                this.contractTypeName = response.data.userProfile.contractTypeDescription;
                this.contractType = response.data.userProfile.contractType;
                console.log(response.data.locationName)
            }
        } catch (ex) {
            this.$fire({
                title: "Error",
                text: "No userProfile found",
                type: "error"
            });
            this.$bvModal.hide('modal-profile-change');
        }
    }
    async openModalProfile() {
     
        await this.fillRegion();
          let responseFromGet = await General.GetUser();
          if (responseFromGet.data != null) {
              var idCountry = responseFromGet.data.idCountry;
              //console.log(responseFromGet.data);
            this.selectedRegion = idCountry;        
        }
        /*this.$bvModal.show('modal-profile-change');*/
    }
    fillRolesArray(arrayRolesName: any[]) {
        return arrayRolesName.filter(x => x != "User");
    }
    //Restituisce un array di stringhe. prendere tale array e passarlo al filler per togliere "user"
    convertRolesToArrayString(userRoles: any[]) {
        let arrayRolesName = [];
        userRoles.forEach(function (item) {
            arrayRolesName.push(item.identityRole.name + '');
        });
        return arrayRolesName;
    }
    async fillRegion() {

        try {
            let response = await General.GetCountriesAll();
            
            this.regionsOptions = [];
            var app = this;
            response.data.forEach(function (item: any) {
                app.regionsOptions.push({
                    value: item.idCountry,
                    text: item.name
                });
            });
        } catch (error) {
            General.showAlertDanger(error, this);
        }
    }
    async CheckAuthorization(){
        let response: any = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/EmergencyContact/CheckUser'),
                data: {
                },
                withCredentials: true,
                responseType: 'json'
            });            
        return response.data
    }
}

